// ----------------------------------------------------------------------
export function select(theme) {
    return {
        MuiSelect: {
            // defaultProps: {
            //   IconComponent: ChevronDown
            // },
            styleOverrides: {
                icon: {
                    right: 18,
                    width: 20,
                    height: 20,
                    top: 'calc(50% - 10px)'
                }
            }
        },
        MuiNativeSelect: {
            styleOverrides: {
                icon: {
                    right: 18,
                    width: 20,
                    height: 20,
                    top: 'calc(50% - 9px)'
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    maxHeight: '500px !important',
                    overflowY: 'auto'
                }
            }
        }
    };
}
